import React, { useState } from 'react';
import { Form, Input, Button } from 'antd';
import ConfirmationModal from '../../../main/components/ConfirmationModal';

export const TenantLists = ({ tenants, addTenant, removeTenant }) => {
  const [newTenantName, setNewTenantName] = useState('');
  const [newTenantUuid, setNewTenantUuid] = useState('');
  const [validUuid, setValidUuid] = useState(true);
  const [uuidAlreadyInUse, setUuidAlreadyInUse] = useState(false);

  const handleAddTenant = (e) => {
    e.preventDefault();
    addTenant(newTenantName, newTenantUuid);
  };

  const uuidValidator = (value) => {
    setValidUuid(
      /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i.test(
        value,
      ),
    );

    setUuidAlreadyInUse(tenants.some((tenant) => tenant.uuid === value));
  };

  const getAddButtonText = () => {
    if (newTenantName.length === 0) {
      return 'Enter tenant name';
    }
    if (newTenantUuid.length === 0) {
      return 'Enter tenant uuid';
    }
    if (!validUuid) {
      return 'Invalid UUID';
    }
    if (uuidAlreadyInUse) {
      return 'UUID already in use';
    }
    return 'Add Tenant';
  };

  return (
    <div className="admin-tenant-input">
      <div className="admin-tenant-input__container-inputs">
        <Form.Item
          label="Tenant name"
          className="admin-input-label admin-tenant-input__form-item"
          style={{ flex: '1' }}
        >
          <Input
            placeholder="name"
            onChange={(e) => {
              setNewTenantName(e.target.value);
            }}
            className="admin-input"
          />
        </Form.Item>
        <Form.Item
          label="Tenant uuid"
          className="admin-input-label admin-tenant-input__form-item"
          style={{ flex: '3' }}
        >
          <Input
            placeholder="uuid"
            onChange={(e) => {
              setNewTenantUuid(e.target.value);
              uuidValidator(e.target.value);
            }}
            className="admin-input"
          />
        </Form.Item>
      </div>
      <div>
        <Form.Item>
          <Button
            type="primary"
            onClick={handleAddTenant}
            disabled={
              !newTenantName || !newTenantUuid || !validUuid || uuidAlreadyInUse
            }
            style={{ width: '100%' }}
          >
            {getAddButtonText()}
          </Button>
        </Form.Item>
      </div>
      <div>
        <div>
          {tenants.map((tenant) => (
            <div
              key={tenant.uuid}
              className="admin-tenant-input__tenant-list-item"
            >
              <div className="admin-tenant-input__tenant-list-item__name">
                {tenant.name}
              </div>
              <div className="admin-tenant-input__tenant-list-item__uuid">
                {tenant.uuid}
              </div>
              <ConfirmationModal
                body="Are you sure you wish to delete this tenant?"
                confirmText="Delete"
                onConfirm={(e) => {
                  e.preventDefault();
                  removeTenant(tenant);
                }}
              >
                <Button type="link" danger ghost>
                  Delete
                </Button>
              </ConfirmationModal>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};
